
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZ_9vS6v4Ap_45oFnl6xGfFyEbiUg4rT671oM_45Oqapry_45QMeta } from "/home/leandro/_git/baeta-advocacia/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_9304WARl5dxEeLuIaYrwkJnJZ1VNVIG_VAvyPKDS7nu_UMeta } from "/home/leandro/_git/baeta-advocacia/pages/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/leandro/_git/baeta-advocacia/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/home/leandro/_git/baeta-advocacia/pages/[...slug].vue")
  }
]